import { useState, useEffect } from "react";
import { ResponsiveBar } from "@nivo/bar";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { supabase } from "@/components/atomic-crm/providers/supabase/supabase";

const tierOrder = ["Angel Target", "High Priority", "Monitor", "Low Fit", "Disqualified"];
const tierColors: Record<string, string> = {
    "Angel Target": "#22c55e",
    "High Priority": "#3b82f6",
    "Monitor": "#eab308",
    "Low Fit": "#9ca3af",
    "Disqualified": "#ef4444",
};

export function ScoreDistribution() {
    const [data, setData] = useState<Array<{ tier: string; count: number; color: string }>>([]);

    useEffect(() => {
        supabase.from("contacts").select("current_tier")
            .not("current_tier", "is", null)
            .then(({ data: contacts }) => {
                if (!contacts) return;
                const counts: Record<string, number> = {};
                contacts.forEach((c: any) => { counts[c.current_tier] = (counts[c.current_tier] || 0) + 1; });
                setData(tierOrder.filter((t) => counts[t]).map((tier) => ({
                    tier,
                    count: counts[tier] || 0,
                    color: tierColors[tier] || "#999",
                })));
            });
    }, []);

    if (data.length === 0) return null;

    return (
        <Card>
            <CardHeader className="pb-2">
                <CardTitle className="text-base">Lead Score Distribution</CardTitle>
            </CardHeader>
            <CardContent>
                <div style={{ height: 200 }}>
                    <ResponsiveBar
                        data={data}
                        keys={["count"]}
                        indexBy="tier"
                        colors={({ data }) => data.color}
                        margin={{ top: 10, right: 10, bottom: 40, left: 40 }}
                        padding={0.3}
                        axisBottom={{ tickRotation: -20 }}
                        axisLeft={{ tickValues: 5 }}
                        enableLabel={true}
                        labelSkipWidth={12}
                        labelSkipHeight={12}
                    />
                </div>
            </CardContent>
        </Card>
    );
}
